import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { actions, slotDetailSelector } from "reducers/slotDetailModal";
import { actions as notificationActions } from "reducers/notification";
import { NotificationStateType } from "reducers/types/notification";
import { UserSlotRequestType } from "sagas/types/slotDetailModal";
import { AppDispatch, RootState } from "store";
import { ConnectedDropdown } from "./ConectedDropdown";
import "../i18n";
import { useTranslation } from "react-i18next";

const ConnectedDropdownContainer = (
  props: ConnectorProps
): JSX.Element => {
  const { t } = useTranslation();

  const showDeleteNotification = (onAccept: () => void) => {
    props.showNotification({
      id: "notification-delete-connected-picker",
      level: "warning",
      title: t("slotDetail:deletePickerTitle"),
      body: t("slotDetail:deletePickerMessage"),
      onConfirmLabel: t("slotDetail:deletePickerButton"),
      onCancelLabel: "global:cancel",
      onConfirm: onAccept,
    });
  };

  const deleteConnectedPicker = (userId: number) => {
    if (userId && props.slot?.id) {
      showDeleteNotification(() =>
        props.removeConnectedPicker({
          pickerId: userId,
          slotId: props.slot.id,
        })
      );
    }
  };

  return (
    <ConnectedDropdown
      users={props.users}
      testId={props.testId}
      slot={props.slot}
      deleteConnectedPicker={deleteConnectedPicker}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  slot: slotDetailSelector(state).slot,
  users: slotDetailSelector(state).pickersConnected,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  removeConnectedPicker: (params: UserSlotRequestType) => {
    dispatch(actions.removeConnectedPickerRequest(params));
  },
  showNotification: (content: NotificationStateType) => {
    dispatch(notificationActions.showNotification(content));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector> & {
  testId?: string;
};

export default connector(ConnectedDropdownContainer);
